export interface DomainEntityBase {
  id: number | string;
  name: string;
}

export enum DomainEntityType {
  Checklist = 'Checklist',
  Location = 'Location',
  Asset = 'Asset',
}
